import { Button, Checkbox, Col, Form, Input, Row, Select, message } from "antd";
import { useContext, useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { IoCallSharp } from "react-icons/io5";
import Layout from "../../Components/Layout/Layout";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import styles from "./ContactUs.module.scss";

const ContactUs = () => {
    const [agreed, setAgreed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { user } = useContext(AuthContext);

    // final submit Function
    const handleSubmit = (values) => {
        setLoading(true);
        values.name = values.first_name + " " + values.last_name;

        axios.post("/contact-us/submit", values).then((response) => {
            message.success("Thanks for reaching us! We will get back to you soon.");
            setLoading(false);
        });

        form.resetFields();
        setLoading(false);
    };
    return (
        <Layout title="Contact Us">
            <div className="container pt-4">
                <div className={styles.top_title}>
                    <img
                        src="https://desi-fresh.b-cdn.net/components_static/sidebar_icons/customer-support-active.svg"
                        alt="coupon"
                        height={40}
                    />
                    <h3>Customer service</h3>
                </div>

                <div
                    style={{
                        marginTop: "20px",
                        maxWidth: 800,
                        marginInline: "auto",
                    }}
                >
                    <Form
                        onFinish={handleSubmit}
                        layout="vertical"
                        requiredMark={false}
                        initialValues={{
                            title: user?.title,
                            first_name: user?.first_name,
                            last_name: user?.last_name,
                            email: user?.email,
                        }}
                        form={form}
                        style={{
                            width: "100%",
                        }}
                    >
                        <Row gutter={[30, 0]} className="w-full">
                            <Col span={24}>
                                <Form.Item
                                    name="title"
                                    label="Title"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a title"
                                        allowClear
                                        options={[
                                            {
                                                name: "Mr.",
                                                value: "Mr.",
                                            },
                                            {
                                                name: "Mrs.",
                                                value: "Mrs.",
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </Col>
                            <Col lg={12} xs={24}>
                                <Form.Item
                                    label="First Name *"
                                    name="first_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your first name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col lg={12} xs={24}>
                                <Form.Item
                                    label="Last Name *"
                                    name="last_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your last name!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col lg={12} xs={24}>
                                <Form.Item
                                    label="Email *"
                                    name="email"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your email!",
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col lg={12} xs={24}>
                                <Form.Item
                                    name="subject"
                                    label="Subject"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a subject"
                                        allowClear
                                        options={[
                                            {
                                                value: "product_quality",
                                                label: "Product quality",
                                            },
                                            {
                                                value: "new_products",
                                                label: "New products",
                                            },
                                            {
                                                value: "didnt_like",
                                                label: "Did not liked the product",
                                            },
                                            {
                                                value: "need_new",
                                                label: "Need a new product due to the defects in the received product",
                                            },
                                            {
                                                value: "damaged_product",
                                                label: "Damage in the received product ",
                                            },
                                            {
                                                value: "wrong_product",
                                                label: "Wrong item sent",
                                            },
                                            {
                                                value: "supplier_request",
                                                label: "Supplier request",
                                            },
                                            {
                                                value: "franchise_applicant",
                                                label: "Franchise applicant",
                                            },
                                            {
                                                value: "suggestion",
                                                label: "Suggestions",
                                            },
                                            {
                                                value: "other",
                                                label: "Other",
                                            },
                                        ]}
                                        listHeight={320}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    label="Your Message"
                                    name="message"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter your message!",
                                        },
                                    ]}
                                >
                                    <Input.TextArea type={"text"} rows={4} />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} style={{ marginBottom: "2rem" }}>
                                    I agree to process my personal data in accordance with the Desi Fresh Data Protection Policy. You can
                                    unsubscribe anytime you do not wish to receive any information about products and promotions from Desi
                                    Fresh.
                                </Checkbox>
                            </Col>

                            <Col span={24}>
                                <Form.Item>
                                    <Button
                                        loading={loading}
                                        disabled={!agreed}
                                        htmlType="submit"
                                        style={{ padding: "0 4rem" }}
                                        type="primary"
                                    >
                                        Send Now
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <div>
                        <Row gutter={[10, 10]}>
                            <Col span={24}>
                                <div
                                    style={{
                                        fontSize: "1.7rem",
                                        fontWeight: 700,
                                    }}
                                >
                                    Want To Speak With Our Customer Support?
                                </div>
                            </Col>
                            <Col lg={8} xs={24}>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "1rem",
                                    }}
                                >
                                    <IoCallSharp size={25} />
                                    <div>
                                        <span>Hotline (Mo. -Sa. 8 -20 Hrs.)</span>
                                        <span>+49 - 8161 - 5193561</span>
                                        <span>Monday - Friday 10:00 -20:00</span>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8} xs={24}>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "1rem",
                                    }}
                                >
                                    <FaMapMarkerAlt size={20} />
                                    <div>
                                        <span>Königsteinstraße 1/3</span>
                                        <span>80807 München Germany</span>
                                        <span style={{ marginTop: 8 }}>Sonnenstraße 7a</span>
                                        <span>85764 Oberschleißheim Germany</span>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8} xs={24}>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "1rem",
                                    }}
                                >
                                    <FiMail size={20} />
                                    <div>
                                        <span
                                            style={{
                                                color: "var(--color-primary)",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            support@dfresh.de
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ContactUs;
